import React from "react";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import EyeIcon from "../../assets/media/eye.png";
import UploadIcon from "../../assets/media/upload.png";

import "./index.css";

class Contracts extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      brands: [],
      loading: true,
    };
  }

  componentDidMount() {
    if (!this.props.location.state && this.props.location.state.role !== 0) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand });

      Firebase.getAllBrands((res) => {
        let brands = res
          .map((item, index) => {
            let new_item = item;
            new_item.id = index;
            return new_item;
          })
          .filter((item) => item && !item.deactive);
        brands.sort(function (a, b) {
          var textA = a.name.toUpperCase();
          var textB = b.name.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        this.setState({ brands, loading: false });
      });
    }
  }

  render() {
    const { brand, loading, brands } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    return (
      <div id="page-container">
        <Header username={username} role={role} brand={brand} />
        <main id="main-container" className="contracts-page-container">
          {loading ? (
            <div className="loading-container">
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            </div>
          ) : (
            <React.Fragment>
              <div className="team-row">
                <div className="team-row-item">Brand</div>
                <div className="team-row-item">NDA</div>
                <div className="team-row-item">Community Licence</div>
                <div className="team-row-item">Concierge Licence</div>
                <div className="team-row-item">User T&Cs</div>
              </div>
              {(brands || []).map((item, index) => (
                <div className="team-row" key={index}>
                  <div className="team-row-item">
                    <div className="logo-container">
                      <img src={item.logo} alt="logo" />
                    </div>
                  </div>
                  <div className="team-row-item">
                    <div className="icon-container primary">
                      <img src={EyeIcon} alt="eye" />
                    </div>
                  </div>
                  <div className="team-row-item">
                    <div className="icon-container secondary">
                      <img src={UploadIcon} alt="upload" />
                    </div>
                  </div>
                  <div className="team-row-item">
                    <div className="icon-container primary">
                      <img src={EyeIcon} alt="eye" />
                    </div>
                  </div>
                  <div className="team-row-item">674</div>
                </div>
              ))}
            </React.Fragment>
          )}
        </main>
      </div>
    );
  }
}

export default Contracts;



// WEBPACK FOOTER //
// ./src/screens/Contracts/index.js